import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

export default class FilterComplexString extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        setFilter: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
        libraryParams: PropTypes.object,
        onChange: PropTypes.func,
        filterKey: PropTypes.string,
        filterValue: PropTypes.string,
        filter: PropTypes.string,
        submitOnKeyPress: PropTypes.bool,
        handleSearch: PropTypes.func,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        libraryParams: {},
    };

    /**
     * Context Types
     *
     * @type Object
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    handleChange = event => {
        const { onChange, filterKey } = this.props;
        onChange(filterKey, event.target.value);
    };

    handleKeyPress = event => {
        const { submitOnKeyPress, onChange, filterKey, handleSearch } = this.props;
        if (submitOnKeyPress && (event.key === 'Enter')) {
            onChange(filterKey, event.target.value);
            handleSearch();
        }
    };

    render() {
        const { placeholder, libraryParams, filter } = this.props;
        const { intl: { formatMessage } } = this.context;
        return (
            <TextField
                inputProps={{ placeholder: placeholder ? formatMessage({ id: placeholder }) : '' }}
                value={filter ? filter: ''}
                margin="normal"
                onChange={this.handleChange}
                onKeyPress={this.handleKeyPress}
                {...libraryParams}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableFilters/Filters/FilterComplexString.jsx